import { SET_LIVE_ASSIGNEES } from 'root/src/client/logic/project/actionIds'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const {	setLiveAssignees } = apiStoreLenses

export default {
	[SET_LIVE_ASSIGNEES]: (state, payload) => setLiveAssignees(payload, state),
}
